const translations = {
  'en-US': {
    'language': 'Language'
  },
  'pt-BR': {
    'language': 'Idioma'
  }
};

export default translations;
